import { render, staticRenderFns } from "./BagsLayout.vue?vue&type=template&id=3e641f88"
import script from "./BagsLayout.vue?vue&type=script&lang=js"
export * from "./BagsLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports